<template>
  <div
    class="assistant-card"
    :class="{
      'assistant-card--expired': assistant.expired,
      'assistant-card--init': isInit
    }"
  >
    <div class="assistant-card__content">
      <div class="assistant-card__header">
        <div class="assistant-card__avatar">
          <img :alt="assistant.assistantName" :src="assistant.avatar" />
        </div>
        <div class="assistant-card__name">{{ assistant.assistantName }}</div>
        <button
          v-if="assistant.canConfig && !isInit"
          class="assistant-card__action"
          :disabled="assistant.isExpired"
          type="button"
          @click="handleSetting(assistant)"
        >
          设置
        </button>
      </div>
      <div class="assistant-card__meta">
        <span class="assistant-card__label">可用人员：</span>
        <el-tooltip
          v-if="assistant.permission"
          :content="assistant.permission"
          placement="top"
          popper-class="assistant-card__permission-tooltip"
        >
          <span class="assistant-card__value">{{ assistant.permission }}</span>
        </el-tooltip>
        <span
          v-else-if="!assistant.permission && [5, 6].includes(+assistant.assistantType)"
          class="assistant-card__value--empty"
          >暂无可用人员，请选择</span
        >
        <i
          class="assistant-card__icon icon-user-settings-line t-iconfont"
          :class="{
            'assistant-card__icon--disabled': assistant.isExpired
          }"
          @click="handleSetPermission(assistant)"
        ></i>
      </div>
    </div>
    <div v-if="assistant.isExpired" class="assistant-card__mask">
      <div class="assistant-card__expired-tag">套餐已过期：{{ assistant.assistantName }}</div>
      <div class="assistant-card__expired-text">请联系专属顾问续费后即可恢复使用</div>
    </div>
  </div>
</template>

<script setup>
defineOptions({
  name: 'AssistantCard'
})

const emit = defineEmits(['setPermission', 'setting'])

defineProps({
  assistant: {
    type: Object,
    required: true
  },
  isInit: {
    type: Boolean,
    default: false
  }
})

const handleSetPermission = (assistant) => {
  if (assistant?.isExpired) {
    return
  }
  emit('setPermission', assistant)
}

const handleSetting = (assistant) => {
  if (assistant?.isExpired) {
    return
  }
  emit('setting', assistant)
}
</script>

<style lang="scss" scoped>
.assistant-card {
  position: relative;
  width: calc((100% - 32px) / 3);
  height: 88px;
  margin-right: 8px;
  margin-bottom: 12px;
  outline: 1px solid #f2f3f5;
  border-radius: 16px;
  box-sizing: border-box;
  background: #fff;
  overflow: hidden;

  &__content {
    padding: 16px;
  }

  &__header {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
  }

  &__avatar {
    width: 32px;
    height: 32px;
    margin-right: 12px;
    border-radius: 50%;
    overflow: hidden;
    flex: 0 0 auto;
    background: #fff;
    border: 0.83px solid #ffffff;
    box-shadow: 0px 0px 5.33px 0px rgba(56, 47, 220, 0.2);

    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__name {
    flex: 1;
    min-width: 0;
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
    color: #323233;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__action {
    height: 24px;
    padding: 0 8px;
    margin-left: 12px;
    border: 1px solid #e5e6eb;
    border-radius: 8px;
    box-sizing: border-box;
    background: #fff;
    color: #646566;
    font-size: 12px;
    line-height: 22px;
    cursor: pointer;
    flex: 0 0 auto;

    &:disabled {
      color: #c8c9cc;
      cursor: not-allowed;
    }
  }

  &__meta {
    display: flex;
    align-items: center;
    font-size: 12px;
    line-height: 16px;
  }

  &__label {
    color: #646566;
    white-space: nowrap;
  }

  &__value {
    flex: 0 1 auto;
    min-width: 0;
    max-width: 100%;
    color: #323233;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__value--empty {
    font-family: PingFang SC;
    font-size: 12px;
    line-height: 16px;
    color: #c8c9cc;
  }

  &__icon {
    margin-left: 8px;
    color: #969799;
    font-size: 14px;
    line-height: 14px;
    flex: 0 0 auto;
    cursor: pointer;

    &--disabled {
      color: #c8c9cc;
      cursor: not-allowed;
    }
  }

  &__mask {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(12px);
    border-radius: 16px;
  }

  &__expired-tag {
    padding: 2px 8px;
    border-radius: 8px;
    background: #ffece8;
    color: #f54e4e;
    font-size: 12px;
    line-height: 16px;
  }

  &__expired-text {
    margin-top: 8px;
    color: #969799;
    font-size: 12px;
    line-height: 16px;
  }

  &--expired {
    .assistant-card__content {
      filter: saturate(0.9);
    }
  }

  &--init {
    width: calc((100% - 24px) / 2);
  }
}
</style>

<style lang="scss">
.assistant-card__permission-tooltip {
  max-width: 320px;
}
</style>
